/* AppScopes.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _14 = "._onzy12x7+._onzy12x7{margin-top:var(--ds-space-075,6px)}";
const _13 = "._onzyw1gv+._onzyw1gv{margin-top:13px}";
const _12 = "._yl5z1b66+._yl5z1b66{margin-yop:var(--ds-space-050,4px)}";
const _11 = "._19bv1q5e{padding-left:1.5em}";
const _10 = "._syazjjyb{color:var(--ds-text-subtle,#42526e)}";
const _9 = "._vwz4gktf{line-height:20px}";
const _8 = "._18u0idpf{margin-left:0}";
const _7 = "._otyridpf{margin-bottom:0}";
const _6 = "._2hwxidpf{margin-right:0}";
const _5 = "._19pkidpf{margin-top:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button';
import { N500, N800 } from '@atlaskit/theme/colors';
import { makeScopeKey } from '@atlassian/mpac-types';
import { Option } from 'funfix-core';
import React, { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _3 = "._1wybdlk8{font-size:14px}";
const _2 = "._k48p1nn1{font-weight:400}";
const DescriptionContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_k48p1nn1 _1wybdlk8 _syaz1fxt", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DescriptionContainer.displayName = 'DescriptionContainer';
}
const ScopesUl = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _2, _3, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wybdlk8 _vwz4gktf _syazjjyb _19bv1q5e", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ScopesUl.displayName = 'ScopesUl';
}
const ScopeLi = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_yl5z1b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ScopeLi.displayName = 'ScopeLi';
}
const ScopesSection = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_onzyw1gv", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ScopesSection.displayName = 'ScopesSection';
}
const ExpandAllDetailsSection = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_onzy12x7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ExpandAllDetailsSection.displayName = 'ExpandAllDetailsSection';
}
const Scopes = props => {
  const [showAllScopes, setShowAllScopes] = useState(false);
  const initialScopesSize = 4;
  const translateScope = _ref6 => {
    let {
      scopesLookup,
      scope
    } = _ref6;
    const description = Option.of(scopesLookup.getIn([makeScopeKey(scope.toUpperCase()), 'description'])).orElseL(() => {
      const scopeSplit = scope.split(':');
      const scopeHalfKey = scopeSplit[scopeSplit.length - 1];
      return Option.of(scopesLookup.getIn([makeScopeKey(scopeHalfKey.toUpperCase()), 'description']));
    }).getOrElse(scope);
    return description;
  };
  const handleExpandAllScopes = () => {
    setShowAllScopes(true);
  };
  const scopesList = showAllScopes ? props.appScopes : props.appScopes.slice(0, initialScopesSize);
  const renderNoScopes = () => /*#__PURE__*/_jsx(ScopesSection, {
    children: /*#__PURE__*/_jsx(DescriptionContainer, {
      children: "This app does not require additional permissions."
    })
  });
  const renderScopes = () => /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ScopesSection, {
      children: /*#__PURE__*/_jsx(DescriptionContainer, {
        children: props.description
      })
    }), /*#__PURE__*/_jsx(ScopesSection, {
      children: /*#__PURE__*/_jsx(ScopesUl, {
        children: props.scopesLookup.fold(_ => scopesList.map(s => /*#__PURE__*/_jsx(ScopeLi, {
          children: s
        }, s)), scopesLookup => scopesList.map(s => /*#__PURE__*/_jsx(ScopeLi, {
          children: translateScope({
            scopesLookup,
            scope: s
          })
        }, s)))
      })
    }), props.appScopes.size > initialScopesSize && !showAllScopes ? /*#__PURE__*/_jsx(ExpandAllDetailsSection, {
      children: /*#__PURE__*/_jsx(Button, {
        appearance: "link",
        onClick: handleExpandAllScopes,
        children: "Expand all details"
      })
    }) : null]
  });
  return props.appScopes.size > 0 ? renderScopes() : renderNoScopes();
};
export default Scopes;